<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">vip信息管理</div>
          <span class="m-title-s">vip信息新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>信息列表
          </div>
          <div class="m-table-btn">
<!--            <el-button @click="openPopup" type="primary" size="">新增诊断信息</el-button>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="money" label="vip价格" width="110" align="center"></el-table-column>
          <el-table-column prop="vipStatus" label="开启状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.vipStatus === '0'" type="success">开启</el-tag>
              <el-tag v-if="scope.row.vipStatus === '1'" type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="850px" center :close-on-click-modal="false">
      <div style="display: flex;">
        <div class="m-open-container" v-loading="formLoading" style="width: 450px;">
          <div class="zs-open-body-ov">
            <el-form :model="form" :rules="rules" ref="form" label-width="105px">
              <el-form-item label="vip标题: " prop="title">
                <el-input v-model="form.title" placeholder="输入标题"></el-input>
              </el-form-item>
              <el-form-item label="vip价格: " prop="money">
                <el-input v-model="form.money" placeholder="输入vip价格"></el-input>
              </el-form-item>
              <el-form-item label="三行提示语: " prop="vipTips">
                <el-input v-model="form.vipTips" type="textarea" autosize placeholder="输入三行提示语"></el-input>
              </el-form-item>
              <el-form-item label="权益说明: " prop="vipExplain">
                <el-input v-model="form.vipExplain" type="textarea" autosize placeholder="输入权益说明"></el-input>
              </el-form-item>
              <el-form-item label="开启状态: " prop="isStatus">
                <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-foote" style="text-align: center;">
            <el-button @click="openState = false">取 消</el-button>
            <el-button type="primary" @click="submit()">确 定</el-button>
          </div>
        </div>
        <div style="margin-left: 20px; width: 300px;">
          <div style="font-weight: bold;">演示</div>
          <div style="font-size: 12px; color: #ff4d51;">内容以“/”符号分隔字段</div>
          <div style="border: 1px solid #dcdcdc;border-radius: 5px;padding: 10px;margin: 5px 0 0 0;">
            <div v-for="(item, index) in form.vipTips.split('/')" :key="index" style="line-height: 20px;">
              {{ item }}
            </div>
          </div>
          <div style="border: 1px solid #dcdcdc;border-radius: 5px;padding: 10px;margin: 5px 0 0 0;">
            <div v-for="(item, index) in form.vipExplain.split('/')" :key="index" style="line-height: 20px;margin: 10px 0 0 0;">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'vipManage',
  data () {
    return {
      openText: '',
      openState: false,
      formLoading: false,
      isLoading: false,
      isStatus: false,
      list: [],
      form: {
        id: '',
        money: '',
        title: '',
        vipTips: '',
        vipExplain: '',
        vipStatus: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        money: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ],
        vipTips: [
          {required: true, message: '请输入三行提示语', trigger: 'blur'}
        ],
        vipExplain: [
          {required: true, message: '请输入权益说明', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    audioDuration (e) {
      this.form.duration = e.duration
    },
    closeDialog: function () {
      this.form = {
        id: '',
        money: '',
        title: '',
        vipTips: '',
        vipExplain: '',
        vipStatus: ''
      }
      this.isStatus = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.vipStatus = this.isStatus ? '0' : '1'
          _this.formLoading = true
          this.$axios.post('/vip/info/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = {
        id: row.id,
        money: row.money,
        title: row.title,
        vipTips: row.vipTips,
        vipExplain: row.vipExplain,
        vipStatus: row.vipStatus
      }
      this.isStatus = row.vipStatus === '0'
      this.openState = true
    },
    // 管理员列表
    loadData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/vip/info/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vip/VipManage.vue